<template>
  <div>
    <h1 class="title is-6 has-text-centered has-text-weight-bold">{{ title }}</h1>
    <div class="chart" ref="chart"></div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { currency, wholeNumber, dateShort } from '@/filters'

google.charts.load('current', {'packages':['corechart']})

export default {
  props: {
    title: {
      required: true
    },
    column: {
      required: true
    },
  },
  data: () => {
    return {
      propertyNameOverrides: {
        'Dart': 'RDD'
      }
    }
  },
  computed: {
    ...mapGetters([
      'orderItemsPlaced',
    ]),
    chartData () {
      let chartData = {}
      const categories = this.orderItemsPlaced.map((item) => item[this.column]).filter(n => n)
      categories.forEach((category) => {
        chartData[category] = this.orderItemsPlaced.filter((item) => item[this.column] === category).reduce((carry, item) => carry + item.quantity, 0)
      })
      return chartData
    }
  },
  methods: {
    drawChart () {
      const options = {
        fontName: 'Nunito',
        // colors: [
        //   '#01579B',
        //   '#0277BD',
        //   '#0288D1',
        //   '#039BE5',
        //   '#03A9F4',
        //   '#29B6F6',
        //   '#4FC3F7',
        //   '#81D4FA',
        //   '#B3E5FC',
        //   '#E1F5FE',
        // ],
        height: 225
      }

      const dataTable = new google.visualization.DataTable()
      dataTable.addColumn('string', 'Category')
      dataTable.addColumn('number', 'Value')

      for(const property in this.chartData) {
        dataTable.addRow([this.propertyNameOverride(property), this.chartData[property]])
      }

      const chart = new google.visualization.PieChart(this.$refs.chart)
      chart.draw(dataTable, options)
    },
    propertyNameOverride (property) {
      return this.propertyNameOverrides[property] || property
    }
  },
  filters: {
    currency,
    wholeNumber,
    dateShort
  },
  created () {
    window.addEventListener('resize', this.drawChart);
  },
  mounted () {
    // window.addEventListener('resize', this.drawChart);
    google.charts.setOnLoadCallback(() => this.drawChart()) 
  }
}
</script>
